import React, { useEffect } from "react";
import { Outlet, Navigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, htmlLangFor } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { smoothScrollTo } from "@/lib/navigation";

const LanguageLayout = () => {
  const { lang } = useParams();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const valid = SUPPORTED_LANGUAGES.includes(lang);

  useEffect(() => {
    if (!valid) return;
    if (i18n.language !== lang) i18n.changeLanguage(lang);
  }, [lang, valid, i18n]);

  useEffect(() => {
    if (!valid) return;
    document.documentElement.lang = htmlLangFor(lang);
    document.title = t("meta.title");
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [lang, valid, t, i18n.language]);

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = window.setTimeout(() => smoothScrollTo(id), 180);
    return () => window.clearTimeout(timer);
  }, [location.hash, location.pathname]);

  if (!valid) return <Navigate to="/ar" replace />;

  return (
    <div className="App">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
        data-testid="skip-to-content-link"
      >
        {t("common.skip_to_content")}
      </a>
      <Header />
      <main id="main-content" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default LanguageLayout;
